import React from 'react';
import { connect } from 'react-redux';
import { isNotLoginOrExpired } from '../../../helpers/Common';
import EventEmitter, { SHOW_GUEST_POPUP } from '../../../helpers/EventEmitter';
import { REDUCER_NAME, changeTimeRange } from './../reducer';
import Const from '../Const';
import { I18n } from 'react-redux-i18n';
import { compose } from 'redux';
import { withComponentId } from './../../../common/ComponentIdContext';

class FilterTime extends React.Component {
  onClick = key => {
    const { componentId, changeTimeRange, user } = this.props;
    if (isNotLoginOrExpired(user) && key !== 'Daily') {
      EventEmitter.dispatch(SHOW_GUEST_POPUP);
      return;
    }
    changeTimeRange(key, componentId);
  };

  render() {
    const { user, timeRangeFilter } = this.props;
    const listTimeRangeByKey = I18n.t('priceData.listTimeRangeByKey');
    return (
      <div>
        <div className="btn-groupcus-line">
          {Const.listTimeRange.map(key => {
            const isLocked = key !== 'Daily';
            const className =
              key === timeRangeFilter
                ? 'btn btn-cus-nomal bg-b-color-3 active'
                : 'btn btn-cus-nomal bg-b-color-3';
            return (
              <a
                href="#"
                className={className}
                key={key}
                onClick={() => this.onClick(key)}
              >
                {listTimeRangeByKey[key]}
                {isNotLoginOrExpired(user) && isLocked && (
                  <i className="icon-padlock locked-function" />
                )}
              </a>
            );
          })}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, { componentId }) => {
  return {
    timeRangeFilter:
      state[REDUCER_NAME].listMultiComponent[componentId].timeRangeFilter,
    i18n: state.i18n,
    user: state.userInfo,
  };
};

const mapDispatchToProps = {
  changeTimeRange,
};

export default compose(
  withComponentId,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(FilterTime);
